// Typed.js initializer for landing page rich-text H2s
(function () {
  function initTyped(headings) {
    if (headings.length === 0) return;

    var h1 = headings[0];
    var h2 = headings.length > 1 ? headings[1] : null;

    // Extract plain text while preserving current HTML for display after typing
    // Preserve HTML (e.g., <strong>)
    var text1 = h1.innerHTML.trim();
    var text2 = h2 ? h2.innerHTML.trim() : '';

    // Prepare targets: add class for custom cursor and clear content
    h1.classList.add('typed');
    h1.classList.add('typed--active');
    h1.innerHTML = '';
    if (h2) {
      h2.classList.add('typed');
      h2.innerHTML = '';
    }

    new Typed(h1, {
      strings: [text1],
      contentType: 'html',
      typeSpeed: 50,
      startDelay: 400,
      showCursor: false,
      cursorChar: '|',
      smartBackspace: false,
      backSpeed: 0,
      backDelay: 0,
      fadeOut: false,
      loop: false,
      onComplete: function () {
        if (!h2) {
          // No second heading; remove cursor after brief pause
          setTimeout(function () {
            var c = h1.parentElement.querySelector('.typed-cursor');
            if (c && c.parentNode) c.parentNode.removeChild(c);
            h1.classList.remove('typed--active');
          }, 150);
          return;
        }
        // Move cursor to second heading
        h1.classList.remove('typed--active');
        h2.classList.add('typed--active');
        // Start second heading
        new Typed(h2, {
          strings: [text2],
          contentType: 'html',
          typeSpeed: 50,
          startDelay: 300,
          showCursor: false,
          cursorChar: '|',
          smartBackspace: false,
          backSpeed: 0,
          backDelay: 0,
          fadeOut: false,
          loop: false,
          onComplete: function () {
            // Remove cursor after all typing finishes
            setTimeout(function () {
              var cursors = h2.parentElement.querySelectorAll('.typed-cursor');
              cursors.forEach(function (c) {
                if (c && c.parentNode) c.parentNode.removeChild(c);
              });
              h2.classList.remove('typed--active');
            }, 150);
          },
        });
      },
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Look for either landing-page class (for backward compatibility) or typing-effect class
    var wrapper =
      document.querySelector('.rich-text--typing-effect .rich-text__wrapper--typing-effect') ||
      document.querySelector('.rich-text--landing-page .rich-text__wrapper--landing-page');
    if (!wrapper || typeof Typed === 'undefined') return;

    var started = false;
    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !started) {
            started = true;
            var headings = wrapper.querySelectorAll('h2.rich-text__heading');
            initTyped(headings);
            obs.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(wrapper);
  });
})();
